module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"dk":{"closedForSummer":"Vi holder sommerferie i uge 28-29","closedForChristmas":"Glædelig Jul og Godt Nytår, Vi holder lukket fra 24. December til 3. Januar"}}')
  delete Component.options._Ctor
}
